import { cn } from '@bem-react/classname';

export const cnToastify = cn('Toastify');
